/* eslint-disable no-nested-ternary */
import PropTypes from 'prop-types';
import queryString from 'querystring';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { setAturHargaSubUserFilter } from '../../../pages/SettingHarga/actions';
import { rebuildDatesFilter } from '../../../utils/builder/registrationMerchant';
import Filter from '../../elements/Filter';
import {
  fetchCities,
  fetchProvinces,
  fetchRegionals,
  fetchDistricts,
  fetchVillages,
} from '../../layouts/PageBase/actions';
import { Fields, initialValues } from './fields';
import styles from './styles.scoped.css';
import { removeDuplicateDataAob } from '../../../utils/builder/common';
function AturHargaSubUserFilter() {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { dataSubUserFilter: values } = useSelector((state) => state.prices);
  const {
    dataRegionals,
    dataProvinces,
    dataCities,
    dataDistricts,
    dataVillages,
    dataDetailUser: {
      regionalId,
      provinceId,
      cityId,
      cities,
      districtId,
      villageId,
    },
  } = useSelector((state) => state.pageBase);
  const [selectedTemp, setSelectedTemp] = useState({
    cityId: [],
    districtId: [],
    villageId: [],
  });

  const dropdownData = {
    regional: [
      { value: '', label: 'Semua Regional' },
      ...dataRegionals.filter((item) => item.value !== ''),
    ],
    provinces: [
      { value: '', label: 'Semua Provinsi' },
      ...dataProvinces.filter((item) => item.value !== ''),
    ],
    cities: [
      { value: '', label: 'Semua Kota/Kab' },
      ...dataCities.filter((item) => item.value !== ''),
    ],
    districts: [
      { value: '', label: 'Semua Kecamatan' },
      ...dataDistricts.filter((item) => item.value !== ''),
    ],
    villages: [
      { value: '', label: 'Semua Kelurahan' },
      ...dataVillages.filter((item) => item.value !== ''),
    ],
  };

  const handleGetAdministrativeArea = (name, params) => {
    const payloadProvince = {
      regional: params?.regional ? JSON.stringify([params?.regional]) : '',
    };
    const payloadCity = {
      ...payloadProvince,
      provinceId: params?.provinceId && JSON.stringify([params?.provinceId]),
    };
    const payloadDistrict = {
      ...payloadCity,
      cityId: params?.cityId && JSON.stringify([params?.cityId]),
    };
    const payloadVillage = {
      ...payloadDistrict,
      districtId: params?.districtId && JSON.stringify([params?.districtId]),
    };

    if (name === 'regional') {
      dispatch(fetchProvinces(payloadProvince));
      dispatch(fetchCities(payloadProvince));
      dispatch(fetchDistricts(payloadDistrict, selectedTemp.districtId));
      dispatch(fetchVillages(payloadVillage, selectedTemp.villageId));
    }
    if (name === 'provinceId') {
      dispatch(fetchCities(payloadCity, selectedTemp.cityId));
      dispatch(fetchDistricts(payloadDistrict, selectedTemp.districtId));
      dispatch(fetchVillages(payloadVillage, selectedTemp.villageId));
    }
    if (name === 'cityId') {
      dispatch(fetchDistricts(payloadDistrict, selectedTemp.districtId));
      dispatch(fetchVillages(payloadVillage, selectedTemp.villageId));
    }
    if (name === 'districtId') {
      dispatch(fetchVillages(payloadVillage, selectedTemp.villageId));
    }
  };

  const handleSearchFilter = (query) => {
    const payloadCity = {
      regional: regionalId ? JSON.stringify([regionalId]) : query?.regional,
      provinceId: query?.provinceId?.length > 4 ? query?.provinceId : '',
      search: query.target.value,
    };
    dispatch(fetchCities(payloadCity, selectedTemp.cityId));
  };

  const handleChangeValues = ({ name, value }) => {
    let filter = {};
    if (name === 'regional') {
      filter = {
        regional: value,
        provinceId: '',
        cityId: '',
        districtId: '',
        villageId: '',
      };
    } else if (name === 'provinceId') {
      filter = {
        ...values,
        regional: regionalId ? regionalId : values.regional,
        [name]: value,
        cityId: '',
        districtId: '',
        villageId: '',
      };
    } else if (name === 'cityId') {
      filter = {
        ...values,
        [name]: value,
        districtId: '',
        villageId: '',
      };
      const originDataTemp = [
        ...selectedTemp.cityId.filter((row) => value.includes(row.value)),
        ...dataCities.filter((row) => value.includes(row.value)),
      ];
      setSelectedTemp((val) => {
        return {
          ...val,
          cityId: removeDuplicateDataAob(originDataTemp, 'value'),
        };
      });
    } else if (name === 'districtId') {
      filter = {
        ...values,
        [name]: value,
        villageId: '',
      };
      const originDataTemp = [
        ...selectedTemp.districtId.filter((row) => value.includes(row.value)),
        ...dataDistricts.filter((row) => value.includes(row.value)),
      ];
      setSelectedTemp((val) => {
        return {
          ...val,
          districtId: removeDuplicateDataAob(originDataTemp, 'value'),
        };
      });
    } else if (name === 'villageId') {
      filter = {
        ...values,
        [name]: value,
      };
      const originDataTemp = [
        ...selectedTemp.villageId.filter((row) => value.includes(row.value)),
        ...dataVillages.filter((row) => value.includes(row.value)),
      ];
      setSelectedTemp((val) => {
        return {
          ...val,
          villageId: removeDuplicateDataAob(originDataTemp, 'value'),
        };
      });
    } else {
      filter = { ...values, [name]: value };
    }
    const newQuery = queryString.stringify({
      ...filter,
      // regional: userRegion ?? '',
    });

    navigate(`?tab=subpangkalan&${newQuery}`);
    handleGetAdministrativeArea(name, filter);
    dispatch(setAturHargaSubUserFilter(filter));
  };

  const handleReset = () => {
    dispatch(
      setAturHargaSubUserFilter({
        ...initialValues,
        regional: regionalId,
        provinceId: provinceId,
        cityId: cityId,
        districtId: districtId,
      })
    );
    navigate('?tab=subpangkalan');
  };

  useEffect(() => {
    if (regionalId !== undefined) {
      dispatch(fetchRegionals());
      const newQuery = rebuildDatesFilter({
        regional: regionalId,
        provinceId: provinceId,
        cityId: cityId,
        districtId: districtId,
        villageId: villageId || '',
      });
      dispatch(setAturHargaSubUserFilter(newQuery));
      handleGetAdministrativeArea('regional', newQuery);
    }
  }, [regionalId]);

  return (
    <Filter
      className={styles.filterContainer}
      fields={Fields({
        values,
        handleChangeValues,
        handleSearchFilter,
        dropdownData,
        regionalId,
        provinceId,
        cityId,
        cities,
      })}
      handleReset={handleReset}
    />
  );
}

export default AturHargaSubUserFilter;

AturHargaSubUserFilter.propTypes = {
  type: PropTypes.string,
};
